import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mini_arrow_right_empty",
  "use": "icon-mini_arrow_right_empty-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-mini_arrow_right_empty\"><path d=\"M401.674667 110.325333c-33.328-33.322667-87.36-33.322667-120.682667 0-32.858667 32.864-33.317333 85.861333-1.365333 119.28l1.365333 1.402667L561.989333 512l-280.997333 280.992c-32.858667 32.864-33.317333 85.861333-1.365333 119.28l1.365333 1.402667c32.864 32.858667 85.861333 33.317333 119.28 1.365333l1.402667-1.365333 341.333333-341.333334c32.858667-32.864 33.317333-85.861333 1.365333-119.28l-1.365333-1.402666-341.333333-341.333334z\" p-id=\"14212\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/mini_arrow_right_empty.svg
// module id = Xymd
// module chunks = 22